import axios from 'axios';
import appConfig from '../config/appConfig';
import { attachAuthSession } from './authSession';

export const httpClient = axios.create({
  baseURL: appConfig.api.baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

attachAuthSession(httpClient);

export default httpClient;
